@if(isPinned){<span class="grid-total-label">{{status?.statusValue}}</span>}
@if(!isPinned){<div class="grid-status" [ngClass]="['--' + text, !isBullet ? 'no-bullet' : '']">
    @if(isBullet){<img [src]="ICONS.BULLET" />}
    <span>{{status?.statusValue}}</span>
</div>}